// gerasimosbekos/bekos-woodcarving-website/GerasimosBekos-bekos-woodcarving-website-6a5f46baca0a10590c671f2bbcb51841d693c3a7/src/constants/images.js

// File: src/constants/images.js - FULLY DYNAMIC WITH CONFIG METHODS

import { TEMPLATE_CONFIG } from '../config/template.config';

const FOLDER = TEMPLATE_CONFIG.cloudinary.folderPrefix;

// Central configuration for all Cloudinary images
export const CLOUDINARY_IMAGES = {
  // Hero images
  hero: {
    main: `${FOLDER}/hero/main.jpg`, // Added .jpg extension
    about: `${FOLDER}/hero/about.jpg`,
    contact: `${FOLDER}/hero/contact.jpg`,
    gallery: `${FOLDER}/hero/gallery.jpg`,
  },
  
  // Footer images
  footer: {
    main: `${FOLDER}/footer/main.jpg`,
    about: `${FOLDER}/footer/about.jpg`,
    contact: `${FOLDER}/footer/contact.jpg`,
    gallery: `${FOLDER}/footer/gallery.jpg`,
  },
  
  // Other images
  other: {
    artist: `${FOLDER}/other/artist.jpg`, 
    logo: `${FOLDER}/other/logo.png`, // Explicitly set to .png (the fix)
    imageTextMain: `${FOLDER}/other/image_text_main.jpg`,
  },
  
  // ⭐ DYNAMIC: Category thumbnails generated from config
  categories: (() => {
    const categoryImages = {};
    
    // Build category images from config using helper method
    TEMPLATE_CONFIG.categories.forEach(cat => {
      const imageName = TEMPLATE_CONFIG.getCategoryImageName(cat.id);
      categoryImages[cat.id] = `${FOLDER}/categories/${imageName}.jpg`; // Assuming .jpg for categories
    });
    
    return categoryImages;
  })()
};

// ⭐ Helper function to get category image by ID
export const getCategoryImage = (categoryId) => {
  return CLOUDINARY_IMAGES.categories[categoryId] 
    || `${FOLDER}/categories/${categoryId}.jpg`;
};